// @ts-ignore
import t from 'title'

export const title = (str: string) => {
  return t(str, {
    special: ['BaseHub', 'OpenAI', 'CMSs', 'SDK', 'API'],
  }) as string
}
